import type { VNode } from "vue";
import { createVNode, render } from "vue";
import EnterChangeDialog from "./index.vue";

interface IOption {
    // 取消卸载的方法
    onVanish?: () => void;
}

const getDivElement = () => {
    return document.createElement("div");
};

const vmMap = new Map();

export let currentContainer = undefined as unknown;

const setComponentToBody = () => {
    const option = {} as IOption;
    const container = (currentContainer = getDivElement());
    const vm: VNode = createVNode(EnterChangeDialog, option);
    option.onVanish = () => {
        render(null, container);
    };
    const appendTo: HTMLElement = document.body;
    render(vm, container);
    appendTo.appendChild(container.firstElementChild!);
    return vm;
};

const enterChangeDialog = () => {
    return new Promise((resolve, reject) => {
        const vm = setComponentToBody();
        vmMap.set(vm, { resolve, reject });
    });
};

export default enterChangeDialog;
